<template>
    <section :class="[
        'block-wrapper', 
        componentClass, 
        colorMode, 
        {
            visible: visible, 
            ready: ready
        }
    ]">
    <div class="row">
        <div class="column small-12 medium-10 medium-offset-1 large-7 large-offset-2 xxlarge-5 xxlarge-offset-3 text-column">
            <div class="wysiwyg-wrapper">
                <div class="row">
                    <div class="column small-12 medium-8 medium-offset-2">
                        <h2 v-if="data.title">{{ data.title }}</h2>
                        <ul v-if="data.files">
                            <li v-for="(file, fileindex) in data.files" :key="data.component_id + '-dl-' + fileindex">
                                <a :href="file.url" class="has-icon icon-right download">{{ file.title }} <span class="file-size">{{ file.size }}</span></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </section>
</template>


<script>
import BaseBlock from './Base'

export default {
    extends: BaseBlock,
    data() {
        return {
            defaultColorMode: 'light',
            componentClass: 'file-downloads',
        }
    }
}
</script>

<style lang="scss">
	@import "../../styles/scss/global/block-wrapper";
	@import "../../styles/scss/component/file-downloads";
</style>